/* eslint-disable */

function getDayName(day) {
    const map = {
        MON: "понедельник",
        TUE: "вторник",
        WED: "среду",
        THU: "четверг",
        FRI: "пятницу",
        SAT: "субботу",
        SUN: "воскресенье",
    };
    return map[day] || day;
}

function pad(value) {
    return value.padStart(2, "0");
}

function decline(number, [one, few, many]) {
    number = parseInt(number);
    if (number % 10 === 1 && number % 100 !== 11) return one;
    if ([2, 3, 4].includes(number % 10) && ![12, 13, 14].includes(number % 100)) return few;
    return many;
}

export const formateCronString = (cron) => {
    const [sec, min, hour, dayOfMonth, month, dayOfWeek, year] = cron.split(" ");

    // Каждые N минут
    if (min.startsWith("0/") && hour === "*" && dayOfMonth === "1/1") {
        const m = min.split("/")[1];
        return m === "1"
            ? "каждую минуту"
            : `каждые ${m} ${decline(m, ["минута", "минуты", "минут"])}`;
    }

    // Каждые N часов
    if (hour.startsWith("0/") && min === "0" && dayOfMonth === "1/1") {
        const h = hour.split("/")[1];
        return `каждые ${h} ${decline(h, ["час", "часа", "часов"])}`;
    }

    // Каждые N дней
    if (dayOfMonth.startsWith("1/") && hour === "0" && min === "0") {
        const d = dayOfMonth.split("/")[1];
        return `каждые ${d} ${decline(d, ["день", "дня", "дней"])}`;
    }

    // Каждую неделю в HH:MM
    if (dayOfMonth === "?" && dayOfWeek !== "?" && month === "*") {
        const time = `${pad(hour)}:${pad(min)}`;
        const days = dayOfWeek.split(",").map(getDayName);
        return `каждый ${days.join(", ")} в ${time}`;
    }

    return "Неизвестный формат";
};


export function generateTimeIntervals() {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let min = 0; min < 60; min += 30) {
            const h = String(hour).padStart(2, "0");
            const m = String(min).padStart(2, "0");
            times.push(`${h}:${m}`);
        }
    }
    return times;
}

export const dayNameListMock = [
    {
        value: "MON",
        name: "ПН",
    },
    {
        value: "TUE",
        name: "ВТ",
    },
    {
        value: "WED",
        name: "СР",
    },
    {
        value: "THU",
        name: "ЧТ",
    },
    {
        value: "FRI",
        name: "ПТ",
    },
    {
        value: "SAT",
        name: "СБ",
    },
    {
        value: "SUN",
        name: "ВС",
    },
];

export const updateFrequencyEveryMock = {
    minutes: [10, 15, 20, 30],
    hours: [1, 2, 3, 4, 6, 12],
    days: [1, 2, 3, 4, 5, 6, 7],
};

export const timeNameListMock = [
    {value: "minutes", name: "минуты"}, {value: "hours", name: "часы"}, {value: "days", name: "дни"}
];